import request from '@/utils/request'

export function getInfo() {
    return request({
        url: '/api/account/getAccountInfo',
        method: 'get'
    })
}
export function getUserInfo() {
    return request({
        url: '/api/account/getUserInfo',
        method: 'get'
    })
}
export function myMsgList() {
    return request({
        url: '/api/account/myMsgList',
        method: 'get'
    })
}

export function readMyMsg(id) {
    return request({
        url: '/api/account/readMsg',
        method: 'post',
        data: {
          id: id
        }
    })
}

export function changePassword(form) {
    return request({
        url: '/api/account/changePassword',
        method: 'post',
        data: {
          password: form.password,
          email:form.email,
          pay_password: form.payPassword
        }
    })
}


export function getQuestionList() {
    return request({
        url: '/api/account/getQuestionList',
        method: 'get'
    })
}
